module.exports = __webpack_public_path__ + "static/media/rin-bg.6fbdcfd1.mp4";